<template>
    <view class="ui-dialog" v-if="visible" @touchmove.stop.prevent="() => {}">
        <view class="ui-dialog__mask ui-dialog__show" @click="type === '1' ? '' : closeDialog()"></view>
        <view class="ui-dialog__main ui-dialog__show">
            <image v-if="type === '1'" class="ui-dialog__main__icon" src="/static/images/network.png" mode=""></image>
            <view class="ui-dialog__main__content">
                <view class="content">{{ content }}</view>
            </view>
            <view class="ui-dialog__main__footer">
                <button v-if="type === '1'" class="ui-button ui-button--raduis first" hover-class="ui-button--hover" @click="onConfirm">{{ btnText }}</button>
                <button v-if="type === '2'" class="ui-button ui-button--raduis first" hover-class="ui-button--hover" @click="closeDialog">{{ btnText }}</button>
            </view>
            <!-- <view v-if="type === '2' && appSystemConfig.features.isService" class="ui-dialog__main__service">
                <button class="ui-button ui-button--plain  ui-button--raduis " hover-class="ui-button--hover" @click="onService">{{ customerServiceText }}</button>
            </view> -->
        </view>
    </view>
</template>
<script setup>
    import { ref } from 'vue';
    import { onLoad } from '@dcloudio/uni-app';
    import { appSystemConfig, serviceLink } from '@/app.config.js';

    const content = ref('');
    const type = ref('1');
    const visible = ref(false);
    const btnText = ref('');
    const customerServiceText = ref('');
    // #ifdef APP
    visible.value = true;
    // #endif
    // #ifdef H5
    visible.value = false;
    // #endif

    const openDialog = (e) => {
        type.value = e.type;
        content.value = e.content;
        btnText.value = e.btnText;
        customerServiceText.value = e.customerServiceText;
        visible.value = true;
    };

    const closeDialog = () => {
        // #ifdef APP-PLUS
        if (getCurrentPages().length > 1) {
            uni.navigateBack();
        } else {
            uni.switchTab({
                url: '/pages/tabbar/home/index'
            });
        }
        // #endif
        // #ifdef H5
        visible.value = false;
        // #endif
    };

    const onConfirm = () => {
        // #ifdef APP-PLUS
        plus.runtime.restart();
        // #endif
        // #ifdef H5
        window.location.reload();
        // #endif
        visible.value = false;
    };

    const onService = () => {
        // #ifdef H5
        window.location.href = serviceLink;
        // #endif
        // #ifdef APP-PLUS
        plus.webview.open(serviceLink);
        // #endif
    };

    onLoad((e) => {
        type.value = e.type;
        content.value = e.content;
        btnText.value = e.btnText;
        customerServiceText.value = e.customerServiceText;
    });

    defineExpose({
        openDialog,
        closeDialog
    });
</script>
<style lang="scss">
    page {
        background: transparent;
    }
</style>
<style lang="scss">
    .ui-dialog {
        &__mask {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 900;
            /* opacity: 0; */
            background: rgba(0, 0, 0, 0.8);
            transition: all 0.3s linear;
        }

        &__main {
            position: fixed;
            top: 50%;
            left: 50%;
            z-index: 999;
            width: 530rpx;
            padding: 30rpx;
            transform: translate(-50%, -50%);
            /* opacity: 0; */
            background: $input-bg;
            border-radius: 30rpx;
            transition: all 0.3s linear;

            &__icon {
                width: 80rpx;
                height: 80rpx;
                display: block;
                margin: 0rpx auto;
                margin-bottom: 20rpx;
            }

            &__title {
                font-size: 30rpx;
                font-weight: bold;
                text-align: center;
                margin-bottom: 40rpx;
            }

            .content {
                font-size: 24rpx;
                text-align: center;
                padding: 0 70rpx;
                color: $text-color;
                line-height: 1.6;
            }

            &__footer {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 40rpx;
                padding: 0 80rpx;

                .ui-button {
                    height: 60rpx;
                    width: 160rpx;
                    font-size: 24rpx;
                    font-weight: normal;
                }
            }

            &__service {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                bottom: -100rpx;
                left: 0px;
                right: 0px;

                .ui-button {
                    height: 60rpx;
                    /* width: 250rpx; */
                    padding: 0rpx 24rpx;
                    font-size: 24rpx;
                    background-color: rgba(217, 217, 217, 0.11);
                    color: $text-color;
                    border: 1rpx solid #999;
                }
            }
        }

        &__show {
            opacity: 1;
        }
    }
</style>
